// AUTO GENERATED FILE - DO NOT EDIT - GENERATED BY cmd/enterprise/*.go generate authz
export default {
	status: 'success',
	data: {
		resources: [
			{
				kind: 'dashboard',
				type: 'metaresource',
				allowedVerbs: ['create', 'delete', 'list', 'read', 'update'],
			},
			{
				kind: 'factor-api-key',
				type: 'metaresource',
				allowedVerbs: ['create', 'delete', 'list', 'read', 'update'],
			},
			{
				kind: 'license',
				type: 'metaresource',
				allowedVerbs: ['create', 'delete', 'list', 'read', 'update'],
			},
			{
				kind: 'quick-filter',
				type: 'metaresource',
				allowedVerbs: ['list', 'read', 'update'],
			},
			{
				kind: 'subscription',
				type: 'metaresource',
				allowedVerbs: ['create', 'delete', 'list', 'read', 'update'],
			},
			{
				kind: 'role',
				type: 'role',
				allowedVerbs: [
					'assignee',
					'attach',
					'create',
					'delete',
					'detach',
					'list',
					'read',
					'update',
				],
			},
			{
				kind: 'serviceaccount',
				type: 'serviceaccount',
				allowedVerbs: [
					'attach',
					'create',
					'delete',
					'detach',
					'list',
					'read',
					'update',
				],
			},
			{
				kind: 'logs',
				type: 'telemetryresource',
				allowedVerbs: ['read'],
			},
			{
				kind: 'meter-metrics',
				type: 'telemetryresource',
				allowedVerbs: ['read'],
			},
			{
				kind: 'metrics',
				type: 'telemetryresource',
				allowedVerbs: ['read'],
			},
			{
				kind: 'traces',
				type: 'telemetryresource',
				allowedVerbs: ['read'],
			},
		],
		relations: {
			assignee: ['role'],
			attach: ['metaresource', 'role', 'serviceaccount'],
			create: ['metaresource', 'role', 'serviceaccount'],
			delete: ['metaresource', 'role', 'serviceaccount'],
			detach: ['metaresource', 'role', 'serviceaccount'],
			list: ['metaresource', 'role', 'serviceaccount'],
			read: ['metaresource', 'role', 'serviceaccount', 'telemetryresource'],
			update: ['metaresource', 'role', 'serviceaccount'],
		},
	},
} as const;
